import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  forwardRef,
  Injector,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputTextarea } from 'primeng/inputtextarea';
import { isNullOrEmpty } from '../../../core/utils/common-functions';
import { BaseComponent } from '../base.component';

export const TEXT_AREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TextAreaComponent),
  multi: true,
};

/**
 * Text Area 元件
 *
 * @export
 * @class TextAreaComponent
 * @extends {BaseComponent}
 * @implements {OnInit}
 * @implements {OnChanges}
 * @implements {AfterViewInit}
 * @implements {ControlValueAccessor}
 */
@Component({
  selector: 'sigv-text-area',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.scss'],
  providers: [TEXT_AREA_VALUE_ACCESSOR],
})
export class TextAreaComponent
  extends BaseComponent
  implements OnInit, OnChanges, AfterViewInit, ControlValueAccessor
{
  /**
   * 最大長度
   */
  @Input() maxLen = 1000;

  /**
   * 列高
   */
  @Input() rows = 3;

  /**
   * Disable
   */
  @Input() ifDisabled = false;

  /**
   * 自動寬度
   */
  @Input() autoResize = true;

  /**
   * 顯示字串長度
   */
  @Input() isShowLength = true;

  @ViewChild(InputTextarea) inputTextarea!: InputTextarea;
  model: any;
  textareaLength = 0;
  onModelChange: (event: any) => void = () => {};
  onModelTouched: (event: any) => void = () => {};

  constructor(private injector: Injector, private cd: ChangeDetectorRef) {
    super(injector);
  }

  ngOnChanges(changes: SimpleChanges): void {}

  ngOnInit(): void {
    this.textareaLength = this.model?.length ?? 0;
  }

  ngAfterViewInit(): void {
    this.updateTextAreaValue(this.model);
    this.cd.detectChanges();
  }

  writeValue(obj: any): void {
    this.model = obj;
    this.updateTextAreaValue(obj);
  }

  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onModelTouched = fn;
  }

  /**
   * textarea key up 事件
   *
   * @param {*} event
   * @memberof TextAreaComponent
   */
  onTextAreaKeyUp(event: any): void {
    const value = event.currentTarget.value;
    this.updateModel(value);
  }

  updateModel(value?: string): void {
    this.model = value;
    this.updateTextAreaValue(value);
    this.onModelChange(value);
  }

  /**
   * 更新 textarea 值
   *
   * @param {string} [value]
   * @memberof TextAreaComponent
   */
  updateTextAreaValue(value?: string): void {
    if (isNullOrEmpty(this.inputTextarea) === false) {
      this.inputTextarea.el.nativeElement.value = value ?? '';
    }
    this.textareaLength = this.model?.length ?? 0;
  }
}
